// React
import { useEffect } from "react"

// Components
import { Loading } from "components"

// Third-Party Libraries
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"

// Utils
import { useApi, useToggle } from "utils"
import { getSourceDetail } from "./utils"

export default function DataSource(): JSX.Element {
  // Hooks
  const api = useApi()
  const navigate = useNavigate()
  const { id } = useParams()
  const { isActive, setActive } = useToggle(true)

  useEffect(() => {
    getSourceDetail(
      api,
      id
    ).then(res => {
      navigate(
        `/purchase/transaction/record-reject/${res}`,
        { replace: true }
      )
    }).catch(() => {
      toast.error("Data not found")
      navigate(-1)
    }).finally(() => {
      setActive(false)
    })

    return () => {
      setActive(true)
    }

    // eslint-disable-next-line
  }, [])

  return <Loading loading={isActive} />
}